var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48321 6.96995C7.48321 7.33807 7.57139 7.65988 7.77008 7.93657H6.24327C6.17104 7.64262 6.13564 7.33889 6.13808 7.03407C6.13808 5.10201 7.66383 3.74707 9.83558 3.74707C11.9276 3.74707 13.4375 5.14238 13.4959 7.13145H12.189C12.0721 5.84895 11.1648 5.06163 9.79839 5.06163C8.49152 5.06163 7.48214 5.77651 7.48214 6.96995H7.48321ZM9.81433 15.8501C7.52677 15.8501 6.00102 14.5355 5.87777 12.5132H7.18464C7.33764 13.7719 8.38421 14.5355 9.88764 14.5355C11.3114 14.5355 12.342 13.6983 12.342 12.5464C12.342 11.5644 11.7608 10.9148 10.3084 10.5574L9.30327 10.3116H1.81689V9.12407H16.6919V10.3116H12.9689C13.4661 10.8305 13.6861 11.4919 13.6861 12.3268C13.6861 14.4951 12.1603 15.8501 9.81433 15.8501Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.2dc98ff2648a777ccb2a914db894a778.svg";
export { ForwardRef as ReactComponent };